import { render, staticRenderFns } from "./LimitedTimeVip.vue?vue&type=template&id=055b6d1d"
import script from "./LimitedTimeVip.vue?vue&type=script&lang=js"
export * from "./LimitedTimeVip.vue?vue&type=script&lang=js"
import style0 from "./LimitedTimeVip.vue?vue&type=style&index=0&id=055b6d1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports